import { Tab, TabBody, TabContent, TabHeader, Tabs } from '../../components/Tabs';
import SpoolsState from '../../context/spools/SpoolsState';
import ActiveSpools from './ActiveSpools';
import CreatorFees from './CreatorFees';
import PlatformSummary from './PlatformSummary';
import Staking from './Staking';
import Gauge from './Gauge';
import DaoVesting from './DAOVesting';
import { useWeb3React } from '@web3-react/core';
import vestingAddresses from '../../config/constants/vestingAddresses.json';
import { SupportedChains } from '../../config/constants';
import { useMemo } from 'react';

const Vault: React.FC = () => {
    const { account, chainId } = useWeb3React();

    const vestingAddress =
        !!vestingAddresses.addresses.filter(
            (address) => account && address.toLowerCase().includes(account?.toLowerCase())
        ).length ||
        vestingAddresses.builderAddress.toLowerCase() === account?.toLowerCase();

    const connectedToMainnet = useMemo(
        () => chainId !== SupportedChains.ARBITRUM_ONE,
        [chainId]
    );

    return (
        <Tabs>
            <TabHeader>
                {connectedToMainnet && <Tab to='/platform-summary'>Platform Summary</Tab>}
                <Tab to='/your-spools'>Your Spools</Tab>
                {connectedToMainnet && <Tab to='/staking'>$SPOOL Staking</Tab>}
                <Tab to='/your-creator-fees'>Your Creator Fees</Tab>
                {connectedToMainnet && <Tab to='/egov'>E-Gov</Tab>}
                {connectedToMainnet && vestingAddress && (
                    <Tab to='/dao-vesting'>DAO Vesting</Tab>
                )}
            </TabHeader>
            <TabBody>
                <TabContent to='/platform-summary'>
                    <PlatformSummary />
                </TabContent>
                <TabContent to='/your-spools'>
                    <SpoolsState initialSortKey='userCurrentBalance'>
                        <ActiveSpools />
                    </SpoolsState>
                </TabContent>
                <TabContent to='/staking'>
                    <Staking />
                </TabContent>
                <TabContent to='/your-creator-fees'>
                    <CreatorFees />
                </TabContent>
                <TabContent to='/egov'>
                    <Gauge />
                </TabContent>
                <TabContent to='/dao-vesting'>
                    <DaoVesting />
                </TabContent>
            </TabBody>
        </Tabs>
    );
};

export default Vault;
